/* eslint-disable camelcase */

import array from './array.png';
import boolean from './boolean.png';
import integer from './integer.png';
import number from './number.png';
import object from './object.png';
import string from './string.png';
import unknown from './unknown.png';
export const typeIcons = {
  array,
  boolean,
  integer,
  number,
  object,
  string,
  unknown
};

/**
 * 获取类型的Icon图的地址
 *
 * @param {string} type
 * @param {string} color
 * @return {string}
 */
export default function getTypeIcon(type /* , color = '' */) {
  const collection = /* color === 'red' ? typeRedIcons : */typeIcons;
  return collection[type] || collection.unknown;
}